import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme } from '@material-ui/core'

export const useOptionGroupStyles = makeStyles((theme: Theme) => ({
    optionGroupContainer: {
        display: 'inline-flex !important',
        flexWrap: 'wrap',
        maxWidth: '99%',
    },
    optionItem: {
        width: 'fit-content',
        fontFamily: 'Roboto',
        fontSize: '14px',
        textAlign: 'center',
        fontWeight: 500,
        border: '1px solid #0D7B55',
        padding: theme.spacing('3px', '8px'),
        paddingRight: theme.spacing(1.4),
        cursor: 'pointer',
        margin: '2px 0px',
        lineHeight: pxToRem(15),
        borderRadius: pxToRem(70),
        wordBreak: 'break-word',
        paddingLeft: theme.spacing(1.5),
        '&:disabled': {
            color: '#CCCCCC',
            border: '1px solid #CCCCCC',
            background: theme.palette.common.white,
            padding: theme.spacing('3px', '10px'),
            cursor: 'default',
        },
        marginLeft: 0,
    },
    optionItemWithEmptyContainer: {
        maxWidth: 'calc(100% - 1px)', // Reserve 1px for EmptyPlainTextContainer
    },
    unselectedOptionItem: {
        color: '#0D7B55',
        background: '#F5FFFC',
        cursor: 'pointer',
    },
    selectedOptionItem: {
        color: '#F5FFFC',
        background: '#0D7B55',
    },
    unavailableOptionItem: {
        color: '#999999',
        background: '#FFFFFF',
    },
    moSelectedOption: {
        color: '#FFFFFF',
        background: '#0764FC',
        border: '1px solid #0764FC',
    },
    moUnselectedOption: {
        color: '#0764FC',
        background: '#FFFFFF',
    },
    inactivatedOptionItem: {
        textDecoration: 'line-through',
        textDecorationColor: 'rgba(0,0,0,0.5) !important',
        color: 'rgba(0,0,0,0.5) !important',
        background: theme.palette.common.white,
        border: '1px solid rgba(0, 0, 0, 0.5)',
        cursor: 'pointer',
    },
    optedOutOptionItem: {
        color: 'rgba(0,0,0,0.5) !important',
        background: theme.palette.common.white,
        border: '1px solid rgba(0, 0, 0, 0.5)',
        cursor: 'default',
    },
    editableText: {
        padding: theme.spacing(0.375, 0.25),
        wordBreak: 'break-word',
        position: 'relative',
        whiteSpace: 'pre-wrap',
        cursor: 'text',
    },
    editableTextBoxed: {
        fontSize: '1.4rem',
        background: '#FFFFFF',
        borderRadius: pxToRem(4),
        lineHeight: '16px',
        height: 'fit-content',
        outline: 'none',
        display: 'inline-block',
        marginTop: '-3px !important',
        marginBottom: '-3px !important',
        whiteSpace: 'nowrap',
    },
    notDisabledBoxedInputContainer: {
        border: '1px solid #0D7B55',
        color: theme.palette.common.black,
        marginRight: theme.spacing(0.25),
    },
    // Disabled state with line-through (for inactive/non-editable content)
    disabledBoxedInputContainer: {
        textDecoration: 'line-through',
        textDecorationColor: 'rgba(0,0,0,0.5) !important',
        color: 'rgba(0,0,0,0.5) !important',
        border: '1px solid rgba(0,0,0,0.5)',
        cursor: 'default',
    },
    // Disabled state without line-through (for products not added to project)
    disabledBoxedInput: {
        color: 'rgba(0,0,0,0.5) !important',
        border: '1px solid rgba(0,0,0,0.5)',
        cursor: 'default',
    },
    replacementOptionNoBackground: {
        background: 'transparent !important',
    },
    uomContainerInlineFlex: {
        display: 'inline-flex',
        margin: `0`,
    },
    uomContainerContent: {
        display: 'contents',
        margin: `${pxToRem(3)} ${pxToRem(5)}`,
    },
    defaultCursor: {
        cursor: 'default',
        pointerEvents: 'none',
    },
    disabledOptionGroup: {
        cursor: 'not-allowed',
        pointerEvents: 'none',
    },
    endIcon: {
        color: theme.palette.common.white,
        fontSize: pxToRem(20),
        marginLeft: theme.spacing(0.5),
        marginRight: theme.spacing(0.5),
        display: 'inline-flex',
        alignItems: 'center',
        verticalAlign: 'middle',
        '& > .bpIconContainer': {
            fontSize: pxToRem(17),
            height: pxToRem(16),
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
    },
    activeBPIcon: {
        color: theme.palette.common.white,
        cursor: 'default',
    },
    bpOptContainer: {
        color: theme.palette.common.white,
        position: 'relative',
        right: pxToRem(3),
        fontSize: pxToRem(17),
        cursor: 'pointer',
        '& > svg': {
            color: 'inherit',
        },
    },
    disabledPill: {
        color: 'rgba(0,0,0,0.38) !important',
        background: theme.palette.common.white,
        border: '1px solid rgba(0,0,0,0.38)',
        cursor: 'default',
        opacity: 0.6,
        pointerEvents: 'none',
    },
}))
